/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const CancelDelete = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={`cancel-delete ${className}`}
      fill="none"
      height="30"
      viewBox="0 0 31 30"
      width="31"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M15.2998 27.5C22.2034 27.5 27.7998 21.9036 27.7998 15C27.7998 8.09644 22.2034 2.5 15.2998 2.5C8.39625 2.5 2.7998 8.09644 2.7998 15C2.7998 21.9036 8.39625 27.5 15.2998 27.5Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        className="path"
        d="M19.0498 11.25L11.5498 18.75"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        className="path"
        d="M11.5498 11.25L19.0498 18.75"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};
